module.exports = __webpack_public_path__ + "static/media/notifications.827b22e9.svg";